import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { PaginatedResponse } from "@/shared/http";

import { type ImageRegistryRecord } from "../ImageRegistryRecord";

export function useImagesByOrg(orgId: string) {
  const { imageRegistryService } = useDomainServices();

  return useQuery<PaginatedResponse<ImageRegistryRecord>, Error>({
    queryKey: ["imageRecords", "org", orgId],
    queryFn: async ({ signal }) => {
      return await imageRegistryService.getImagesForRepository(null, {
        orgId: orgId,
        abortSignal: signal,
      });
    },
    staleTime: 60000,
  });
}
